// extracted by mini-css-extract-plugin
module.exports = {"title-modal":"_3-eLKcxO86SqTscdcm2Y9P","dialog":"vPhlPD1x3oVufp43_A_Vo"};